export enum HardBlockReason {    
    Anatomy = 0,
    Weight = 1,
    Age = 2,
    Mismatch = 3,
    Antibodies = 4,
    Bulk = 5,
    Other = 6,
    EpletMismatch = 7
}